import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Link from '@mui/material/Link';
import EntityTableRow, { EntityTableRowProps } from 'components/EntityTableRow';
import TableCell from 'components/TableCell';

import { CountriesListRow_country$key } from '__generated__/CountriesListRow_country.graphql';

type Props = EntityTableRowProps & {
  country: CountriesListRow_country$key;
};

const CountriesListRow: FC<Props> = ({ country, ...props }) => {
  const countryData = useFragment(
    graphql`
      fragment CountriesListRow_country on Country {
        id
        name

        ...EntityTableRow_entity
      }
    `,
    country
  );

  const { id, name } = countryData;

  return (
    <EntityTableRow entity={countryData} {...props}>
      <TableCell>
        <Link href={id}>{name}</Link>
      </TableCell>
    </EntityTableRow>
  );
};

export default CountriesListRow;
